export default __webpack_public_path__ + "static/media/ic_android.cd690eb4.svg";